import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import HomePageV2 from './HomePageV2';
import HeadsUp from './HeadsUp';
import EliteHeadsUp from './EliteHeadsUp';
import MeetTheNewbbis from './MeetTheNewbbis';
import PeluchesPage from './PeluchesPage';
import CreatorPage from './CreatorPage';
import UniversesList from './UniversesList';
import UniversePage from './UniversePage';
import CharacterPage from './CharacterPage';
import RegistroCreador from './RegistroCreador';
import GuessTheName from './GuessTheName';
import DailyNubbi from './DailyNubbi';
import RegisterWithPassword from './RegisterWithPassword';
import RegisterWithUsername from './RegisterWithUsername';
import WhatIsNubbi from './WhatIsNubbi';
import MemoryGame from './MemoryGame';
import NubbiHunt from './NubbiHunt';
import NubbiBWChallenge from './NubbiBWChallenge';
import NubbiWallpaper from './NubbiWallpaper';
import NubbiGrid from './NubbiGrid';
import RateTheNubbis from "./RateTheNubbis";
import MadnessMenu from "./MadnessMenu";
import NubbiMadnessRandom from "./NubbiMadnessRandom";
import NubbiMadnessMulti from "./NubbiMadnessMulti";
import NubbiMadness from "./NubbiMadness";
import NubbucksPage from './NubbucksPage';
import NubbiSMPage from './NubbiSMPage';
import CreateNubbi from './CreateNubbi';
import NubbiSquads from './NubbiSquads';
import CreatorsPageV2 from './CreatorsPageV2';
import NubbiLabInstructions from './NubbiLabInstructions';
import Discover from './Discover';
import DiscoverV2UltraPro from './DiscoverV2UltraPro';
import IntroVideo from './IntroVideo';
import OurTeam from './OurTeam';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePageV2 />} />
        <Route path="/headsup" element={<HeadsUp />} />
        <Route path="/elite-headsup" element={<EliteHeadsUp />} />
        <Route path="/meetthenewbbis" element={<MeetTheNewbbis />} />
        <Route path="/peluches" element={<PeluchesPage />} />
        <Route path="/creador/:nombre" element={<CreatorPage />} />
        <Route path="/universes-list" element={<UniversesList />} />
        <Route path="/universo/:codigo" element={<UniversePage />} />
        <Route path="/character/:id" element={<CharacterPage />} />
        <Route path="/register" element={<RegisterWithPassword />} />
        <Route path="/register-username" element={<RegisterWithUsername />} />
        <Route path="/guess-the-name" element={<GuessTheName />} />
        <Route path="/daily-nubbi" element={<DailyNubbi />} />
        <Route path="/what-is-nubbi" element={<WhatIsNubbi />} />
        <Route path="/memorygame" element={<MemoryGame />} />
        <Route path="/nubbi-hunt" element={<NubbiHunt />} />
        <Route path="/nubbi-bw-challenge" element={<NubbiBWChallenge />} />
        <Route path="/nubbi-wallpaper" element={<NubbiWallpaper />} />
        <Route path="/nubbigrid" element={<NubbiGrid />} />
        <Route path="/rate" element={<RateTheNubbis />} />
        <Route path="/madness" element={<MadnessMenu />} />
        <Route path="/madness/random" element={<NubbiMadnessRandom />} />
        <Route path="/madness/multi" element={<NubbiMadnessMulti />} />
        <Route path="/madness/top" element={<NubbiMadness />} />
        <Route path="/nubbucks" element={<NubbucksPage />} />
        <Route path="/nubbi-sm" element={<NubbiSMPage />} />
        <Route path="/create-nubbi" element={<CreateNubbi />} />
        <Route path="/squads" element={<NubbiSquads />} />
        <Route path="/creadores-v2" element={<CreatorsPageV2 />} />
        <Route path="/nubbilab" element={<NubbiLabInstructions />} />
        <Route path="/discover" element={<Discover />} />
        <Route path="/discover-ultra" element={<DiscoverV2UltraPro />} />
        <Route path="/intro-video" element={<IntroVideo />} />
        <Route path="/our-team" element={<OurTeam />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;